import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";
import Breakpoints from "common/breakpoints";

export default makeStyles((theme: MuiTheme) => {
  const { primary, secondary } = theme.palette;

  return {
    rootResults: {
      borderBottom: "none"
    },
    buttonsGroup: {
      width: "67%",
      marginTop: -6,
      [theme.breakpoints.down(Breakpoints.SM_600)]: {
        width: "100%"
      }
    },
    buttonsGroupItem: {
      height: 35
    },
    textareaField: {
      "& .MuiInputBase-root": {
        color: "#2d2d2d",
        fontSize: 12
      },
      "& .MuiOutlinedInput-root fieldset": {
        borderColor: "#ccc"
      },
      "& .MuiOutlinedInput-multiline": {
        padding: "12px 9px 12px 12px"
      },
      "& .MuiOutlinedInput-root:hover fieldset": {
        borderColor: primary.main
      },
      "& .MuiOutlinedInput-root.Mui-focused fieldset": {
        borderWidth: 1,
        borderColor: secondary.dark
      }
    },
    conclusionField: {
      width: "67%",
      [theme.breakpoints.down(Breakpoints.SM_600)]: {
        width: "100%"
      }
    },
    internalNote: {
      color: primary.light
    },
    removeButton: {
      padding: 9,
      marginRight: -12,
      color: primary.dark,
      "& .MuiSvgIcon-root": {
        width: 20,
        height: 20
      }
    },
    addTrainerComment: {
      fontSize: 13,
      textTransform: "none",
      paddingRight: 3
    }
  };
});
